// extracted by mini-css-extract-plugin
export var authorsWrapper = "post-module--authors-wrapper--rkZ2M";
export var languageWrapper = "post-module--language-wrapper--npq+I";
export var postMainTitle = "post-module--post-main-title--oPmm6";